import React from 'react'
import { Outlet } from 'react-router-dom'

import Footer from '@component/Footer'
import NavBar from '@component/Navbar'
import SideBar from '@component/Sidebar/SideBar'

class DashboardLayout extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            isMobile: true
        }

        this.previousWidth = -1
    }

    updateWidth() {
        const width = window.innerWidth
        const widthLimit = 576
        const isMobile = width <= widthLimit
        const wasMobile = this.previousWidth <= widthLimit

        if (isMobile !== wasMobile) {
            this.setState({
                isOpen: !isMobile
            });
        }

        this.previousWidth = width
    }

    componentDidMount() {
        this.updateWidth();
        window.addEventListener('resize', this.updateWidth.bind(this))
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth.bind(this))
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }


    render() {
        return (

            <div className='wrapper' >
                <SideBar toggle={this.toggle} isOpen={this.state.isOpen} />

                <div className='main'>
                    <NavBar toggle={this.toggle} isOpen={this.state.isOpen} />

                    <main className='content'>
                        <div className='container-fluid'>
                            <Outlet />
                        </div>
                    </main>

                    <Footer />
                </div>
            </div>

        )
    }
}

export default DashboardLayout;